import { render, staticRenderFns } from "./HKBanksForm.vue?vue&type=template&id=3af85ee2&scoped=true&"
import script from "./HKBanksForm.vue?vue&type=script&lang=js&"
export * from "./HKBanksForm.vue?vue&type=script&lang=js&"
import style0 from "./HKBanksForm.vue?vue&type=style&index=0&id=3af85ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af85ee2",
  null
  
)

export default component.exports